var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('div',{staticClass:"sidebar-container"},[_c('SideMenu')],1),_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"fixed-header"},[_c('TopHeader')],1),_c('div',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }